import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import bootstrapCss from "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import normalizeCss from "normalize.css";
import fontawesomeCss from "@fortawesome/fontawesome-free/css/all.min.css";
import s from "./styles.scss";

class LayoutStyles extends React.Component<any, any> {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export default withStyles(
  normalizeCss,
  bootstrapCss,
  fontawesomeCss,
  s
)(LayoutStyles);
